import { render, staticRenderFns } from "./Logs.vue?vue&type=template&id=2d150226&"
import script from "./Logs.vue?vue&type=script&lang=js&"
export * from "./Logs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d150226')) {
      api.createRecord('2d150226', component.options)
    } else {
      api.reload('2d150226', component.options)
    }
    module.hot.accept("./Logs.vue?vue&type=template&id=2d150226&", function () {
      api.rerender('2d150226', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/Logs.vue"
export default component.exports